import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Registor.vue"),
  },
  {
    path: "/download",
    name: "Download",
    component: () => import("../views/Download.vue"),
  },
  {
    path: "/userAgreement",
    name: "UserAgreement",
    component: () => import("../views/Agreement.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
